/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { Switch, Route,BrowserRouter, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Tables from "./pages/Tables";
import MlModel from "./pages/MlModel";
import Firmware from "./pages/Firmware";
import MetricsModule from "./pages/MetricsModule";
import Dashboard from "./pages/Dashboard";


import Billing from "./pages/Billing";
import BillingPage from "./pages/BillingPage";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Coupon from "./pages/Coupon";
import CheckoutPage from "./pages/CheckoutPage";



import PaymentRedirect from "./pages/PaymentRedirect";


import ShareCoupon from "./pages/ShareCoupon";


import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/pdstyle.css";
  // import "./assets/styles/glass-theme.css";
import AuthRoute from "./components/AuthRoute";


const authRole = (["admin"].indexOf(localStorage.getItem("is_role")) !==-1 ? true : false);
localStorage.setItem("is_notification",true);
console.log(authRole);

// function App() {
//   return (
    
//     <BrowserRouter>
//       <Route exact path="/sign-in" component={SignIn} />
//       <AuthRoute exact path="/" component={Tables} />
//       {/* <AuthRoute exact path="/tables" component={Tables} /> */}
//       {/* <Redirect from="*" to="/tables" /> */}
//     </BrowserRouter>
//   );
// }

function App() {
  return (
    <div className="App">
      <Switch>
        {/* <Route path="/sign-up" exact component={SignUp} /> */}
        <Route path="/sign-in" exact component={SignIn} />

        <Route path="/checkout-page" exact component={CheckoutPage} />

        
    
        <Route path="/coupon-redeem" exact component={Coupon} />
        <Route path="/gift-share" exact component={ShareCoupon} />

        <Route path="/payment-redirection" exact component={PaymentRedirect} />
            
        {localStorage.getItem("is_auth") ? 
        <Main>
          {/* <Route exact path="/dashboard" component={Home} /> */}
          <Route exact path="/dashboard" component={Dashboard} />

{/*
          {authRole ? <Route exact path="/ml-model" component={MlModel} /> : "" }

          {authRole ? <Route exact path="/metric-json" component={MetricsModule} /> : "" }

          {authRole ? <Route exact path="/firmware-list" component={Firmware} /> : "" }*/}
          
          {/* <Route exact path="/billing" component={Billing} /> */}
          <Route exact path="/billing" component={BillingPage} />
          {/* <Route exact path="/rtl" component={Rtl} /> */}
          {/* <Route exact path="/dashboard" component={Profile} /> */}
          <Redirect from="*" to="/dashboard" />
        </Main> :  <Redirect from="*" to="/sign-in" />
        }
      </Switch>
    </div>
  );
}

export default App;
